import { render } from "./TreatmentInput.vue?vue&type=template&id=e39c7c7a"
import script from "./TreatmentInput.vue?vue&type=script&lang=js"
export * from "./TreatmentInput.vue?vue&type=script&lang=js"
script.render = render

export default script